import {
  MicrofrontendEvents,
  onDispatchToastNotification,
  publish,
} from '@sennder/senn-node-microfrontend-event-bus'

export const notify = (
  message: string,
  category: onDispatchToastNotification['category']
) => {
  publish<onDispatchToastNotification>({
    name: MicrofrontendEvents.onDispatchToastNotification,
    data: {
      message,
      category,
    },
  })
}
